//  @flow

import React from 'react';
import { useTranslation } from 'react-i18next';

import ListGroup from '../../Components/ListGroup';
import IncrementCard from './../../Components/IncrementCard';

import CourseImage_png from '../../Assets/v2/home/course.png';
import LiveProjectImage_png from '../../Assets/v2/home/live-project.png';
import MentorImage_png from '../../Assets/v2/home/mentor.png';
import PlacedImage_png from '../../Assets/v2/home/placed.png';
import StudentImage_png from '../../Assets/v2/home/student.png';
import WebinarImage_png from '../../Assets/v2/home/webinar.png';

import CourseImage_webp from '../../Assets/v2/home/course.webp';
import LiveProjectImage_webp from '../../Assets/v2/home/live-project.webp';
import MentorImage_webp from '../../Assets/v2/home/mentor.webp';
import PlacedImage_webp from '../../Assets/v2/home/placed.webp';
import StudentImage_webp from '../../Assets/v2/home/student.webp';
import WebinarImage_webp from '../../Assets/v2/home/webinar.webp';

import CourseImage_fallback from '../../Assets/fallbacks/home/course.jpg';
import LiveProjectImage_fallback from '../../Assets/fallbacks/home/live-project.jpg';
import MentorImage_fallback from '../../Assets/fallbacks/home/mentor.jpg';
import PlacedImage_fallback from '../../Assets/fallbacks/home/placed.jpg';
import StudentImage_fallback from '../../Assets/fallbacks/home/student.jpg';
import WebinarImage_fallback from '../../Assets/fallbacks/home/webinar.jpg';

const Figures = () => {
  const { t } = useTranslation();
  return (
    <ListGroup containerClassName="figure-container" count={3}>
      <IncrementCard
        fallbackImage={StudentImage_fallback}
        title={t('figuresStudents')}
        webpImage={StudentImage_webp}
        image={StudentImage_png}
        toValue={2500}
      />

      <IncrementCard
        fallbackImage={LiveProjectImage_fallback}
        title={t('figuresLiveProjects')}
        webpImage={LiveProjectImage_webp}
        image={LiveProjectImage_png}
        toValue={200}
      />

      <IncrementCard
        fallbackImage={PlacedImage_fallback}
        title={t('figuresColleges')}
        webpImage={PlacedImage_webp}
        image={PlacedImage_png}
        toValue={250}
      />

      <IncrementCard
        fallbackImage={CourseImage_fallback}
        title={t('figuresCourses')}
        webpImage={CourseImage_webp}
        image={CourseImage_png}
        toValue={10}
      />

      <IncrementCard
        fallbackImage={MentorImage_fallback}
        title={t('figuresMentors')}
        webpImage={MentorImage_webp}
        image={MentorImage_png}
        toValue={250}
      />

      <IncrementCard
        fallbackImage={WebinarImage_fallback}
        title={t('figuresWebinars')}
        webpImage={WebinarImage_webp}
        image={WebinarImage_png}
        toValue={150}
      />
    </ListGroup>
  );
};

export default Figures;



// WEBPACK FOOTER //
// ./src/Pages/Home/Figures.js